// Accessible tab component from https://inclusive-components.design/tabbed-interfaces/
// This component functions on:
// template-news-events-listing.blade.php
// template-tabbed.blade.php

export default class Tabs {
  constructor(el) {
    // Get relevant elements and collections
    const tabbed = el;
    const tablist = tabbed.querySelector("ul");
    const tabs = tablist.querySelectorAll("a");
    const panels = tabbed.querySelectorAll('[id^="section"]');

    // The tab switching function
    const switchTab = (oldTab, newTab) => {
      newTab.focus();
      // Make the active tab focusable by the user (Tab key)
      newTab.removeAttribute("tabindex");
      // Set the selected state
      newTab.setAttribute("aria-selected", "true");

      // conditional for template-tabbed.php
      if(newTab.parentElement.className == 'TabbedTemplate-item') {
        newTab.parentElement.classList.add('selected');
      }

      oldTab.removeAttribute("aria-selected");
      oldTab.setAttribute("tabindex", "-1");

      // conditional for template-tabbed.php
      if(oldTab.parentElement.className == 'TabbedTemplate-item selected') {
        oldTab.parentElement.classList.remove('selected');
      }
      // Get the indices of the new and old tabs to find the correct
      // tab panels to show and hide
      let index = Array.prototype.indexOf.call(tabs, newTab);
      let oldIndex = Array.prototype.indexOf.call(tabs, oldTab);
      panels[oldIndex].hidden = true;
      panels[index].hidden = false;
    };

    // Add the tablist role to the first <ul> in the .tabbed container
    tablist.setAttribute("role", "tablist");

    // Add semantics are remove user focusability for each tab
    Array.prototype.forEach.call(tabs, (tab, i) => {
      tab.setAttribute("role", "tab");
      tab.setAttribute("id", "tab" + (i + 1));
      tab.setAttribute("tabindex", "-1");
      tab.parentNode.setAttribute("role", "presentation");

      // Handle clicking of tabs for mouse users
      tab.addEventListener("click", e => {
        e.preventDefault();
        let currentTab = tablist.querySelector("[aria-selected]");
        if (e.currentTarget !== currentTab) {
          switchTab(currentTab, e.currentTarget);
        }
      });

      // Handle keydown events for keyboard users
      tab.addEventListener("keydown", e => {
        // Get the index of the current tab in the tabs node list
        let index = Array.prototype.indexOf.call(tabs, e.currentTarget);
        // Work out which key the user is pressing and
        // Calculate the new tab's index where appropriate
        let dir =
          e.which === 37
            ? index - 1
            : e.which === 39
            ? index + 1
            : e.which === 40
            ? "down"
            : null;
        if (dir !== null) {
          e.preventDefault();
          // If the down key is pressed, move focus to the open panel,
          // otherwise switch to the adjacent tab
          dir === "down"
            ? panels[i].focus()
            : tabs[dir]
            ? switchTab(e.currentTarget, tabs[dir])
            : void 0;
        }
      });
    });

    // Add tab panel semantics and hide them all
    Array.prototype.forEach.call(panels, (panel, i) => {
      panel.setAttribute("role", "tabpanel");
      panel.setAttribute("tabindex", "-1");
      panel.setAttribute("aria-labelledby", tabs[i].id);
      panel.hidden = true;
    });

    // Initially activate the first tab and reveal the first tab panel
    tabs[0].removeAttribute("tabindex");
    tabs[0].setAttribute("aria-selected", "true");
    panels[0].hidden = false;

    // conditional for template-tabbed.php
    if(tabs[0].parentElement.className == 'TabbedTemplate-item') {
      tabs[0].parentElement.classList.add('selected');
    }
    // console.log(tabs[0].parentElement.className);
  }
}

const init = () => {
  document.querySelectorAll(".Tabbed").forEach(el => {
    new Tabs(el);
  });
};

// Init on initial page load
init();

